import clsx from 'clsx';
import { Icon, Text } from '@shared/widgets';
import DotsIcon from '@assets/icons/dots.svg';

export interface IReportsChooseProps {
  text: string;
  onChange: () => void;
  defaultChecked: boolean;
}

export const ReportsChoose = (props: IReportsChooseProps) => {
  return (
    <div className='mb-4'>
      <label className='m-0 flex items-center justify-between'>
        <input type='checkbox' className='hidden' defaultChecked={props.defaultChecked} onChange={props.onChange} />
        <div
          className={clsx(
            'relative inline-flex items-center cursor-pointer w-11 h-6 rounded-full transition-colors duration-200 ease-in-out',
            props.defaultChecked ? 'bg-primary' : 'bg-gainsborough dark:bg-gray-white',
          )}
        >
          <span
            className={clsx(
              'absolute w-5 h-5 bg-white rounded-full transition-transform duration-150 ease-in-out',
              props.defaultChecked ? 'translate-x-5' : 'translate-x-1',
            )}
          />
        </div>
        <div className='order-[-1] flex items-center pr-2 cursor-grab'>
          <Icon icon={<DotsIcon />} />
          <Text className='m-0' size='sm'>
            {props.text}
          </Text>
        </div>
      </label>
    </div>
  );
};
